import React, { useContext } from 'react';

import { Ellipsis } from '@gravity-ui/icons';
import { Button, DropdownMenu, Icon } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { RevisionContext } from 'client/blocks/RevisionActions/RevisionActions';
import { moment } from 'client/lib/moment';
import { InstallableApp } from 'client/model/skill';
import * as keyset from 'i18n/RevisionStatus';

import styles from './RevisionStatus.module.scss';

const t = i18n(keyset);

interface Props {
    revision: InstallableApp['revisions'][number];
    isCurrentRevision: boolean;
    actionDisabled: boolean;
}

export const RevisionRow = ({ revision, isCurrentRevision, actionDisabled }: Props) => {
    const dateString = moment(revision.publishedAt).format('MMM DD, HH:mm').replace('.', '');
    const formatted = dateString[0].toUpperCase() + dateString.slice(1);

    const { handleMoveToDraft, handleNavigateToRevision, handleOpenPublishRevisionModal } = useContext(RevisionContext);

    if (!handleMoveToDraft || !handleNavigateToRevision || !handleOpenPublishRevisionModal) return null;

    return (
        <li className={clx(styles.row, isCurrentRevision && styles.rowActive)}>
            <Button
                className={styles.rowDropdownButton}
                onClick={() => handleNavigateToRevision(revision)}
                size="xs"
                view="flat"
            >
                {formatted}
            </Button>
            <DropdownMenu
                renderSwitcher={(props) => (
                    <Button {...props} className={styles.rowDropdownButton} view="flat" disabled={actionDisabled}>
                        <Icon data={Ellipsis} />
                    </Button>
                )}
                items={[
                    {
                        action: () => handleOpenPublishRevisionModal(revision.id),
                        text: t('revision-make-active'),
                    },
                    {
                        action: () => handleMoveToDraft(revision.id),
                        text: t('revision-move-to-draft'),
                    },
                ]}
                disabled={actionDisabled}
            />
        </li>
    );
};
